import React from "react"
import { DEFAULT_INITIAL_LOAD_NUM_POSTS } from "@data/constants"
import { getRecords, queries, request } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import { datoModels } from "@data/static"
import ProductArchive from "@components/product/ProductArchive/ProductArchive"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"


const Products = ({ edits, options, seo }) => {
  return (
    <Layout options={options}>
      <Seo global={seo} title="The Shop" description="Shop the Edits curated by the HOPP team." />
      <ProductArchive edits={edits} />
    </Layout>
  )
}

export default Products

export async function getStaticProps() {
  const { seo } = await request({ query: `{ ${queries.seo} }` })
  const edits = await getRecords(datoModels.PRODUCT_EDIT, DEFAULT_INITIAL_LOAD_NUM_POSTS)
  const options = await loadOptionsData()
  return {
    props: { edits: edits.records, options, seo },
  }
}
